/**
 * Lightweight wrapper around GA4 + Plausible custom event tracking.
 * Safely no-ops if neither tracker is configured.
 */
export const trackEvent = (eventName, params = {}) => {
  if (typeof window === "undefined") return;
  try {
    if (typeof window.gtag === "function") {
      window.gtag("event", eventName, params);
    }
    if (typeof window.plausible === "function") {
      window.plausible(eventName, { props: params });
    }
  } catch (e) {
    // never throw analytics errors into the UI
  }
};
